import PropTypes from 'prop-types';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

// material-ui
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';

// assets
import DownOutlined from '@ant-design/icons/DownOutlined';

// project import
import NavItem from './NavItem';
import hasActiveChild from './hasActiveChild';
import { useGetMenuMaster } from 'api/menu';

// ==============================|| NAVIGATION - LIST SUB-GROUP (2. seviye accordion) ||============================== //

export default function NavSubGroup({ item }) {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  const { pathname } = useLocation();

  const [open, setOpen] = useState(() => hasActiveChild(item.children, pathname));

  const children = item.children?.map((menuItem) => <NavItem key={menuItem.id} item={menuItem} level={2} />);

  // mini (daraltılmış) drawer'da alt-grup başlığı gösterilmez, ikonlar düz liste olarak kalır
  if (!drawerOpen) {
    return children;
  }

  const SubGroupIcon = item.icon;

  return (
    <List component="div" disablePadding sx={{ py: 0 }}>
      <ListItemButton onClick={() => setOpen((prev) => !prev)} sx={{ pl: 5, pr: 2, py: 0.75, '&:hover': { bgcolor: 'primary.lighter' } }}>
        {SubGroupIcon && (
          <ListItemIcon sx={{ minWidth: 24, flexShrink: 0, color: 'text.secondary' }}>
            <SubGroupIcon style={{ fontSize: '0.875rem' }} />
          </ListItemIcon>
        )}
        <ListItemText
          sx={{ minWidth: 0 }}
          primary={
            <Typography
              variant="body2"
              sx={{ color: 'text.secondary', fontSize: '0.8125rem', whiteSpace: 'normal', wordBreak: 'break-word' }}
            >
              {item.title}
            </Typography>
          }
        />
        <ListItemIcon sx={{ minWidth: 'auto', flexShrink: 0, ml: 0.5, color: 'text.secondary' }}>
          <DownOutlined
            style={{ fontSize: '0.625rem', transform: open ? 'rotate(0deg)' : 'rotate(-90deg)', transition: 'transform 0.2s' }}
          />
        </ListItemIcon>
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </List>
  );
}

NavSubGroup.propTypes = { item: PropTypes.object };
